// Visitenkarl-Marke fürs Portal: Karl-Icon plus Wortmarke (Fraunces, "karl" im Akzent).
export function BrandMark({ className = 'h-8 w-8' }: { className?: string }) {
  return <img src="/graphics/visitenkarl-icon.svg" alt="" aria-hidden="true" className={`${className} shrink-0`} />;
}

export default function Brand({ size = 'md' }: { size?: 'md' | 'lg' }) {
  const lg = size === 'lg';
  return (
    <span className="inline-flex items-center gap-2.5" aria-label="Visitenkarl">
      <BrandMark className={lg ? 'h-10 w-10' : 'h-8 w-8'} />
      <span className={`font-display font-semibold tracking-tight text-ink ${lg ? 'text-2xl' : 'text-xl'}`}>
        Visiten<span className="text-accent-600 dark:text-accent-400">karl</span>
      </span>
    </span>
  );
}
